module.exports = "<div class=\"list-group autocomplete\" *ngIf=\"arr\">\n\t<div class=\"list-group-item bg-info\" [ngClass]=\"{'active':value==data.code}\" *ngFor=\"let data of arr\" (click)=\"onChoose(data)\">{{data[display]}}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/wamp/www/sportal/pmi/web/src/app/shared/autocomplete/autocomplete.component.html
// module id = ../../../../../src/app/shared/autocomplete/autocomplete.component.html
// module chunks = main